import { render, staticRenderFns } from "./webPreview.vue?vue&type=template&id=0a2c4484&scoped=true&"
import script from "./webPreview.vue?vue&type=script&lang=js&"
export * from "./webPreview.vue?vue&type=script&lang=js&"
import style0 from "./webPreview.vue?vue&type=style&index=0&id=0a2c4484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2c4484",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\tavo\\source\\repos\\GEG\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0a2c4484', component.options)
    } else {
      api.reload('0a2c4484', component.options)
    }
    module.hot.accept("./webPreview.vue?vue&type=template&id=0a2c4484&scoped=true&", function () {
      api.rerender('0a2c4484', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src\\views\\reports\\webPreview.vue"
export default component.exports